// extracted by mini-css-extract-plugin
module.exports = {"link":"works-module--link--3pQcM","featured_work_item":"works-module--featured_work_item--3xO-m","titles":"works-module--titles--2ZZeT","section":"works-module--section--1c1oP"};